const config = {
    // baseurl: "https://websitebackend148.infoxtechnologies.com/",
    // imgurl: "https://websitebackend148.infoxtechnologies.com",
    baseurl: "https://websitebackend97.altostechnologies.in",
    imgurl: "https://websitebackend97.altostechnologies.in",
};

export default config;